export const DesignDivider = ({
  height = "80px",
  type = "solid",
  color = "#ddd",
}) => {
  return (
    <div
      className="d-none d-md-block"
      style={{
        borderLeft: `2px ${type} ${color}`,
        height: height,
        width: "1px",
      }}
    ></div>
  );
};
